import './MailConfirmed.css';
import {SquareButton, HeaderBig, HeaderWithButton} from '../common/Common';
import {useSearchParams} from 'react-router-dom';
import { LocaleContext, LoginContext } from '../common/App';
import { useContext } from 'react';
import { useNavigateSmart } from '../common/hooks';

export function MailConfirmed(props) {
    const navigate = useNavigateSmart();
    const login = useContext(LoginContext);
    const locale = useContext(LocaleContext);

    const [searchParams, setSearchParams] = useSearchParams();  
  
    // Get the value of the query parameter you're interested in  
    const username = searchParams.get("username");

    const toCollectData = login.loggedIn && (login.username === username) && !login.dataCollected;

    return (
        <div className="mail_confirmed">
            <HeaderWithButton noBtn={true} langSelection={true} />

            <div className="mail_confirmed_content side_padding">
                <div className="head">{locale.msgs.EMAIL_CONFIRMED}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.START_TEXT}}></div>
            </div>

            <div id="btn">
                <SquareButton text={ toCollectData ? locale.msgs.GO_TO_DATA_COLLECTION : locale.msgs.GO_TO_LOGIN } clickable={true}
                    onClick={ toCollectData ? (e) => navigate("/collect_data/sensitive_data") : (e) => navigate("/login") }/>
            </div>
        </div>
    );
}
